import { useEffect, useState } from 'react';

const API = 'https://ticobaterias.com/api';
const token = () => localStorage.getItem('token');

export default function Bci() {
  const [codigos, setCodigos] = useState<any[]>([]);
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState<any>(null);
  const [form, setForm] = useState({ codigo: '', descripcion: '', orden: 0 });
  const [confirmId, setConfirmId] = useState<number|null>(null);
  const [cargando, setCargando] = useState(false);
  const [toast, setToast] = useState('');

  const mostrarToast = (msg: string) => { setToast(msg); setTimeout(() => setToast(''), 3000); };

  const cargar = async () => {
    const r = await fetch(`${API}/bci/admin`, { headers: { Authorization: `Bearer ${token()}` } });
    setCodigos(await r.json());
  };

  useEffect(() => { cargar(); }, []);

  const abrirNuevo = () => { setEditando(null); setForm({ codigo: '', descripcion: '', orden: 0 }); setModal(true); };
  const abrirEditar = (b: any) => { setEditando(b); setForm({ codigo: b.codigo, descripcion: b.descripcion||'', orden: b.orden||0 }); setModal(true); };

  const guardar = async () => {
    setCargando(true);
    try {
      const url = editando ? `${API}/bci/${editando.id}` : `${API}/bci/`;
      const r = await fetch(url, {
        method: editando ? 'PUT' : 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
        body: JSON.stringify({ ...form, orden: Number(form.orden) })
      });
      if (!r.ok) throw new Error();
      await cargar();
      setModal(false);
      mostrarToast(editando ? '✅ Código actualizado' : '✅ Código agregado');
    } catch { mostrarToast('❌ Error al guardar'); }
    setCargando(false);
  };

  const eliminar = async (id: number) => {
    await fetch(`${API}/bci/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token()}` } });
    setConfirmId(null);
    await cargar();
    mostrarToast('🗑️ Código eliminado');
  };

  return (
    <div>
      {toast && (
        <div className="fixed top-6 right-6 z-50 bg-white border border-gray-200 shadow-xl rounded-xl px-5 py-3 text-sm font-semibold text-gray-700">{toast}</div>
      )}

      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-azul">Banco BCI</h1>
          <p className="text-gray-500 text-sm mt-1">Códigos BCI internacionales de baterías</p>
        </div>
        <button onClick={abrirNuevo}
          className="bg-rojo hover:bg-rojo-dark text-white px-5 py-2.5 rounded-xl font-semibold text-sm transition-all">
          + Agregar Código BCI
        </button>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        {codigos.length === 0 ? (
          <div className="text-center py-16 text-gray-400">
            <div className="text-4xl mb-3">🔋</div>
            <div className="font-medium">No hay códigos BCI</div>
            <div className="text-sm mt-1">Agregá el primero con el botón de arriba</div>
          </div>
        ) : (
          <table className="w-full">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-100">
                <th className="text-left px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider">Código BCI</th>
                <th className="text-left px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider">Descripción</th>
                <th className="text-left px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider">Orden</th>
                <th className="text-left px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider">Estado</th>
                <th className="text-right px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider">Acciones</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {codigos.map(b => (
                <tr key={b.id} className="hover:bg-gray-50/50 transition-colors">
                  <td className="px-6 py-4">
                    <span className="bg-azul text-white text-sm font-black px-3 py-1 rounded">{b.codigo}</span>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-600">{b.descripcion || '—'}</td>
                  <td className="px-6 py-4 text-sm text-gray-500">{b.orden}</td>
                  <td className="px-6 py-4">
                    <span className={`text-xs px-2 py-1 rounded-full font-bold ${b.activo ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'}`}>
                      {b.activo ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right">
                    <button onClick={() => abrirEditar(b)} className="text-azul hover:text-azul-dark font-medium text-sm mr-4 transition-colors">Editar</button>
                    <button onClick={() => setConfirmId(b.id)} className="text-rojo hover:text-rojo-dark font-medium text-sm transition-colors">Eliminar</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Modal confirmar */}
      {confirmId !== null && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6">
            <div className="text-4xl text-center mb-3">🗑️</div>
            <h3 className="text-lg font-bold text-gray-800 text-center mb-2">¿Eliminar código BCI?</h3>
            <p className="text-sm text-gray-500 text-center mb-6">Esta acción no se puede deshacer.</p>
            <div className="flex gap-3">
              <button onClick={() => setConfirmId(null)} className="flex-1 px-4 py-2.5 rounded-xl border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button onClick={() => eliminar(confirmId)} className="flex-1 px-4 py-2.5 rounded-xl bg-rojo hover:bg-rojo-dark text-white text-sm font-semibold">Sí, eliminar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal formulario */}
      {modal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-40 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
            <div className="p-6 border-b border-gray-100">
              <h2 className="text-lg font-bold text-azul">{editando ? 'Editar Código BCI' : 'Nuevo Código BCI'}</h2>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Código BCI *</label>
                <input value={form.codigo} onChange={e => setForm({...form, codigo: e.target.value})}
                  placeholder="Ej: 24F, 35, 51R, 65..."
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul uppercase" />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Descripción</label>
                <input value={form.descripcion} onChange={e => setForm({...form, descripcion: e.target.value})}
                  placeholder="Ej: Batería estándar para sedán japonés"
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul" />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Orden</label>
                <input type="number" min="0" value={form.orden} onChange={e => setForm({...form, orden: Number(e.target.value)})}
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul" />
              </div>
            </div>
            <div className="p-6 border-t border-gray-100 flex gap-3 justify-end">
              <button onClick={() => setModal(false)} className="px-5 py-2.5 rounded-xl border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button onClick={guardar} disabled={cargando || !form.codigo}
                className="px-5 py-2.5 rounded-xl bg-rojo hover:bg-rojo-dark text-white text-sm font-semibold disabled:opacity-50">
                {cargando ? 'Guardando...' : editando ? 'Guardar Cambios' : 'Agregar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
